module.exports = __webpack_public_path__ + "static/media/footpath.71b2c821.svg";